import React from 'react';
import * as PropTypes from 'prop-types';
import * as S from './styles';
import MenuContainer from './MenuContainer';
/**
 * @public
 */

/**
 * 定义页面主体的内容结构。可以包含内容导航菜单，通过{@link IContentProps.menu | menu属性}传入。
 * @public
 */

var Content = function Content(_ref) {
  var className = _ref.className,
      style = _ref.style,
      _ref$adjustHeight = _ref.adjustHeight,
      adjustHeight = _ref$adjustHeight === void 0 ? 'consoleBaseTopbarRoot' : _ref$adjustHeight,
      menu = _ref.menu,
      children = _ref.children;
  return React.createElement(S.Content, {
    className: className,
    style: style
  }, menu && React.createElement(S.ContentSide, null, React.createElement(MenuContainer, {
    adjustHeight: adjustHeight
  }, menu)), React.createElement(S.ContentMain, null, children));
};

Content.propTypes = {
  className: PropTypes.string,
  style: PropTypes.objectOf(PropTypes.any),
  menu: PropTypes.node,
  adjustHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  children: PropTypes.node
};
export default Content;